import { ComplianceRulesInterface, HolderRulesInterface, TokenInformationInterface } from '../token/token-configuration.interface';

const DEPLOY = 'Will deploy the smart contract to the Ethereum Blockchain';
const CONNECT = 'Will connect to an existing smart contract';

export interface PlanInterface {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputs: { [parameter: string]: any };
  description: string;
  type: 'CONTRACT_DEPLOYMENT' | 'CONTRACT_INTERACTION';
  abiName: string;
}

export const compliancePlan = (complianceRules: ComplianceRulesInterface, description?: string): PlanInterface => {
  const deployStatus = 'useDefault' in complianceRules && !complianceRules.complianceAddress;
  return {
    inputs: complianceRules,
    description: description ? description : deployStatus ? DEPLOY : CONNECT,
    type: deployStatus ? 'CONTRACT_DEPLOYMENT' : 'CONTRACT_INTERACTION',
    abiName: 'Compliance',
  };
};

export const claimTopicsPlan = (holderRules: HolderRulesInterface, description?: string): PlanInterface => {
  if (holderRules.identityRegistryAddress === undefined || holderRules.identityRegistryAddress === null)
    return {
      inputs: holderRules.claimRules,
      description: description ? description : DEPLOY,
      type: 'CONTRACT_DEPLOYMENT',
      abiName: 'ClaimTopicsRegistry',
    };
  return {
    inputs: holderRules,
    description: description ? description : CONNECT,
    type: 'CONTRACT_INTERACTION',
    abiName: 'IdentityRegistry / ClaimTopicsRegistry',
  };
};

export const trustedIssuersPlan = (holderRules: HolderRulesInterface, description?: string): PlanInterface => {
  if (holderRules.identityRegistryAddress === undefined || holderRules.identityRegistryAddress === null) {
    return {
      inputs: holderRules.trustedIssuersRules,
      description: description ? description : DEPLOY,
      type: 'CONTRACT_DEPLOYMENT',
      abiName: 'TrustedIssuersRegistry',
    };
  }
  return {
    inputs: holderRules,
    description: description ? description : CONNECT,
    type: 'CONTRACT_INTERACTION',
    abiName: 'IdentityRegistry / TrustedIssuersRegistry',
  };
};

export const identityRegistryPlan = (holderRules: HolderRulesInterface, description?: string): PlanInterface => {
  if (holderRules.identityRegistryAddress !== undefined && holderRules.identityRegistryAddress !== null) {
    return {
      inputs: holderRules,
      description: description ? description : CONNECT,
      type: 'CONTRACT_INTERACTION',
      abiName: 'IdentityRegistry',
    };
  }
  return {
    inputs: holderRules,
    description: description ? description : DEPLOY,
    type: 'CONTRACT_DEPLOYMENT',
    abiName: 'IdentityRegistry',
  };
};

export const tokenPlan = (token: TokenInformationInterface, description?: string): PlanInterface => {
  return {
    inputs: token,
    description: description ? description : DEPLOY,
    type: 'CONTRACT_DEPLOYMENT',
    abiName: 'Token',
  };
};
